import { apiClient } from "../lib/api";

export const leaveApi = {
  listEmployeesForLeave: () => apiClient.get("/employees/leave-lookup"),
  dashboardSummary: () => apiClient.get("/leave/dashboard-summary"),

  // Policies
  listPolicies: () => apiClient.get("/leave/policies"),
  createPolicy: (payload) => apiClient.post("/leave/policies", payload),
  approvePolicy: (id) => apiClient.post(`/leave/policies/${id}/approve`),

  // Grants & eligibility
  checkEligibility: (employeeId, policyId) => apiClient.get(`/leave/employees/${employeeId}/eligibility`, { params: { policy_id: policyId } }),
  grantLeave: (payload) => apiClient.post("/leave/grants", payload),
  listGrants: (employeeId) => apiClient.get("/leave/grants", { params: { employee_id: employeeId || undefined } }),
  manualAdjustment: (payload) => apiClient.post("/leave/manual-adjustment", payload),

  // Employee ledger/balance (management view)
  employeeLedger: (employeeId) => apiClient.get(`/leave/employees/${employeeId}/ledger`),
  employeeBalance: (employeeId) => apiClient.get(`/leave/employees/${employeeId}/balance`),

  // Requests (management review)
  listRequests: (employeeId, status) => apiClient.get("/leave/requests", { params: { employee_id: employeeId || undefined, status: status || undefined } }),
  approveRequest: (id, notes) => apiClient.post(`/leave/requests/${id}/approve`, { notes }),
  rejectRequest: (id, notes) => apiClient.post(`/leave/requests/${id}/reject`, { notes }),
  cancelRequest: (id, reason) => apiClient.post(`/leave/requests/${id}/cancel`, { reason }),

  // Employee self-service
  myBalance: () => apiClient.get("/leave/my/balance"),
  myLedger: () => apiClient.get("/leave/my/ledger"),
  myRequests: () => apiClient.get("/leave/my/requests"),
  submitMyRequest: (payload) => apiClient.post("/leave/my/requests", payload),
  cancelMyRequest: (id, reason) => apiClient.post(`/leave/my/requests/${id}/cancel`, { reason }),

  // Mandatory paid-leave-usage tracking
  mandatoryUseRollup: (status) => apiClient.get("/leave/mandatory-use", { params: { status: status || undefined } }),
  employeeMandatoryUse: (employeeId) => apiClient.get(`/leave/employees/${employeeId}/mandatory-use`),
  waiveMandatoryUse: (grantId, reason) => apiClient.post(`/leave/grants/${grantId}/mandatory-use/waive`, { reason }),
  myMandatoryUse: () => apiClient.get("/leave/my/mandatory-use"),
};
